<template>
    <!-- container :容器 居中布局 -->
    <header class="bg-light  container">
        <!-- 主标题 -->
        <!-- fw-bold : 字体加粗 display-5 : 标题的字体大小 mb-3: 底部的外边距3单位 tracking-wide : 标题的字间距加宽 -->
        <h1 class="fw-bold text-center display-3 mb-3 tracking-wide"> {{ title }}</h1>
        <!-- 副标题 -->
        <!-- text-white/80 : 字体颜色为白色且透明度为80%(这里为白色背景看不出效果) mb-4:底部外边距为4单位 max-w-2xl：最大宽度2xl mx-auto: 水平(x轴)居中 -->
        <p class="text-center text-white/80 mb-4 max-w-2xl mx-auto">发现优质商品，享受便捷购物体验</p>
        <!-- 轮播图区域 -->
        <!-- slide:添加轮播图的效果 carousel-fade : 淡入淡出效果  data-bs-ride="carousel":自动播放 -->
        <div class="carousel-container">
            <div id="carouselExampleFade" class="carousel slide " data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="0" class="active"
                        aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="1"
                        aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="2"
                        aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="3"
                        aria-label="Slide 4"></button>
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="4"
                        aria-label="Slide 5"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src="../assets/水果/苹果.png" class="d-block" alt="苹果">
                    </div>
                    <div class="carousel-item">
                        <img src="../assets/水果/西瓜.png" class="d-block" alt="西瓜">
                    </div>
                    <div class="carousel-item">
                        <img src="../assets/酒/威士忌.png" class="d-block" alt="威士忌">
                    </div>
                    <div class="carousel-item">
                        <img src="../assets/穿搭/绿色工装裤.png" class="d-block" alt="绿色工装裤">
                    </div>
                    <div class="carousel-item">
                        <img src="../assets/酒/白葡萄酒.png" class="d-block" alt="白葡萄酒">
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">上一张</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">下一张</span>
                </button>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '欢迎来到华仔购物总站'
        }
    }
}
</script>

<style lang="less" scoped>
header {
    /* 移除header的默认内边距 */
    padding: 0;
}

/* 轮播图容器样式 */
.carousel-container {
    max-width: 1200px;
    /* 上下2rem外边距 水平居中 */
    margin: 2rem auto;
    /* 阴影效果 */
    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2);
    /* 圆角效果 */
    border-radius: 20px;
    /* 超出部分隐藏 */
    overflow: hidden;
}

/* 轮播图内容区域样式 */
.carousel-inner {
    /* 内容区域高度 */
    height: 26rem;

    // 响应式调整
    @media (max-width: 992px) {
        height: 20rem;
    }

    @media (max-width: 768px) {
        height: 16rem;
    }

    @media (max-width: 576px) {
        height: 12rem;
    }
}

/* 轮播图图片样式 */
.carousel-item img {
    // 图片填充模式:覆盖
    object-fit: cover;
    // 高度宽度继承父元素
    height: 100%;
    width: 100%;
}

/* 轮播图控制按钮样式 */
.carousel-control-prev-icon,
.carousel-control-next-icon {
    width: 1.4rem;
    height: 1.4rem;
    // 给按钮添加背景颜色和圆角 显得易见和易用
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
}

// 轮播图指示点样式
.carousel-indicators [data-bs-target] {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    margin: 0 8px;
    // 0.7透明度的白色
    background-color: rgba(255, 255, 255, 0.7);
}

// 被激活的指示点样式
.carousel-indicators .active {
    background-color: rgb(158, 206, 139);
}
</style>
